import { render, staticRenderFns } from "./CustomerPreviewSection.vue?vue&type=template&id=320cf225&"
import script from "./CustomerPreviewSection.vue?vue&type=script&lang=js&"
export * from "./CustomerPreviewSection.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPreviewSection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports